import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from 'components/AppIcon';

const ROUTE_LABELS = {
  '/volunteer-dashboard': 'Dashboard',
  '/volunteer-registration': 'Register',
  '/training-courses-catalog': 'Training Catalog',
};

const ROUTE_PARENTS = {
  '/training-courses-catalog': { label: 'Dashboard', path: '/volunteer-dashboard' },
};

export default function Breadcrumb({ customCrumbs = null }) {
  const location = useLocation();
  const currentPath = location?.pathname;

  const buildCrumbs = () => {
    if (customCrumbs) return customCrumbs;

    const crumbs = [];
    const parent = ROUTE_PARENTS?.[currentPath];
    const currentLabel = ROUTE_LABELS?.[currentPath];

    if (!currentLabel) return [];

    if (parent) {
      crumbs?.push({ label: parent?.label, path: parent?.path });
    }

    crumbs?.push({ label: currentLabel, path: currentPath, isCurrent: true });
    return crumbs;
  };

  const crumbs = buildCrumbs();

  if (crumbs?.length <= 1) return null;

  return (
    <nav className="breadcrumb-nav" aria-label="Breadcrumb">
      <Link to="/volunteer-dashboard" className="breadcrumb-link" aria-label="Go to home">
        <Icon name="Home" size={14} color="currentColor" />
      </Link>
      {crumbs?.map((crumb, index) => (
        <React.Fragment key={crumb?.path}>
          <span className="breadcrumb-separator" aria-hidden="true">
            <Icon name="ChevronRight" size={14} color="currentColor" />
          </span>
          {crumb?.isCurrent ? (
            <span className="breadcrumb-current" aria-current="page">
              {crumb?.label}
            </span>
          ) : (
            <Link to={crumb?.path} className="breadcrumb-link">
              {crumb?.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}